var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dp_brand",staticClass:"brand flex-column-auto",attrs:{"id":"dp_brand"}},[_c('div',{staticClass:"brand-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('Logo'),_c('img',{staticClass:"side-logo",attrs:{"src":"/image/side-logo.png?v=1.0.2","alt":"Modussoft Logo"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }